// Help Centre structure: the User Manual chapters (in the order of the sidebar menu) and which manual page each
// screen's "?" opens. Pages themselves are Markdown files in help/manual/<chapter>/<page>.md (see CLAUDE.md).

export const HELP_VERSION = "3.94";
/** Old addresses that now forward to a current screen (old → new). Help links and "?" links never point at them. */
export const OLD_ADDRESSES: Record<string, string> = {
  "/app/finance/suppliers": "/app/finance/ledgers", "/app/finance/agents": "/app/finance/ledgers", "/app/finance/freight": "/app/finance/ledgers",
  "/app/finance/customs": "/app/finance/ledgers", "/app/landed": "/app/finance/ledgers",
};

export const CHAPTERS: Array<[string, string]> = [
  ["getting-started", "Getting started"],
  ["dashboard", "Dashboard & My Tasks"],
  ["development", "Development – R&D, Tech Packs, Artwork Library"],
  ["products", "Products – Garments, Fabrics, Trims"],
  ["purchase-orders", "Purchase Orders"],
  ["critical-path", "Time & Action Plan"],
  ["sampling", "Sampling"],
  ["quality", "Quality – QC and Compliance"],
  ["logistics", "Logistics"],
  ["inventory", "Inventory"],
  ["finance", "Finance"],
  ["partners", "Partners"],
  ["reports", "Reports"],
  ["crm", "Falcon CRM"],
  ["settings", "Settings"],
  ["account", "Account & security"],
  ["general", "Printing, exports and search"],
  ["support", "Help & support"],
];
export const CHAPTER_TITLE = Object.fromEntries(CHAPTERS) as Record<string, string>;

/** Screen → manual page. Matched against the address (path + "?tab=…" when there is a tab), most specific first. */
export const CONTEXT_HELP: Array<[RegExp, string]> = [
  [/^\/app\/po\/[^/]+.*[?&]tab=samples/, "po-samples-tab"],
  [/^\/app\/po\/[^/]+.*[?&]tab=activity/, "po-history"],
  [/^\/app\/po\/[^/]+.*[?&]tab=labels/, "po-labels-packaging"],
  [/^\/app\/po\/[^/]+.*[?&]tab=finance/, "supplier-payments"],
  [/^\/app\/po\/[^/]+.*[?&]tab=fabric/, "po-bulk-fabric"],
  [/^\/app\/po\/[^/]+.*[?&]tab=revisions/, "purchase-orders"],
  [/^\/app\/po\/[^/]+.*[?&]tab=plan/, "po-container-planning"],
  [/^\/app\/po\/[^/]+.*[?&]tab=comments.*[?&]vis=shared/, "comments-with-supplier"],
  [/^\/app\/po\/[^/]+.*[?&]tab=comments/, "comments-mentions"],
  [/^\/app\/po\/[^/]+\/document/, "pdf-exports"],
  [/^\/app\/po/, "purchase-orders"],
  [/^\/app\/critical/, "critical-path"],
  [/^\/app\/sampling\?(.*&)?stage=fabric/, "bulk-fabric-tests"],
  [/^\/app\/sampling\?(.*&)?stage=labdip/, "lab-dips"],
  [/^\/app\/sampling/, "sampling-ticking"],
  [/^\/app\/samples/, "samples-to-send"],
  [/^\/app\/qc\/ready/, "ready-for-qc"],
  [/^\/app\/qc\/mine/, "ready-for-qc"],
  [/^\/app\/qc\/inspect\//, "qc-inspection-steps"],
  [/^\/app\/qc\/report\//, "qc-replies"],
  [/^\/app\/qc/, "qc"],
  [/^\/app\/compliance/, "compliance"],
  [/^\/app\/shipments\/[^/]+\/packing/, "packing-lists"],
  [/^\/app\/shipments\/[^/]+\/loading/, "container-loading"],
  [/^\/app\/shipments/, "shipment-control"],
  [/^\/app\/inventory\/enquiry/, "goods-received-enquiry"],
  [/^\/app\/inventory\/(receipts|receive)/, "goods-receive"],
  [/^\/app\/inventory\/(adjustments|transfers)/, "stock-adjustments"],
  [/^\/app\/inventory\/opening/, "inventory-settings"],
  [/^\/app\/inventory/, "stock-on-hand"],
  [/^\/app\/landed\/[^/]+\/print/, "landed-costing"],
  [/^\/app\/performance/, "supplier-performance"],
  [/^\/app\/reports\/timeline/, "order-timeline"],
  [/^\/app\/settings\/crm/, "crm-settings"],
  [/^\/app\/(settings|crm)\/price-lists/, "crm-price-lists"],
  [/^\/app\/(settings|crm)\/costs/, "crm-cost-prices"],
  [/^\/app\/(settings|crm)\/commission/, "crm-commission"],
  [/^\/app\/crm\/reports\/sales/, "crm-sales-reports"],
  [/^\/app\/crm\/reports/, "crm-reports"],
  [/^\/app\/crm\/quotes/, "crm-quotes"],
  [/^\/app\/crm\/orders/, "crm-orders"],
  [/^\/app\/crm\/deals/, "crm-deals"],
  [/^\/app\/crm\/products/, "crm-products"],
  [/^\/app\/crm\/tasks/, "crm-tasks"],
  [/^\/app\/crm\/contacts/, "crm-customer-page"],
  [/^\/app\/crm\/(customers|leads)\/[^/]+/, "crm-customer-page"],
  [/^\/app\/crm\/(customers|leads)/, "crm-customers-leads"],
  [/^\/app\/crm\/?$/, "crm-today"],
  [/^\/app\/activity/, "activity-log"],
  [/^\/app\/settings\/activity/, "activity-log"],
  [/^\/app\/techpacks\/po-labels\//, "po-labels-packaging"],
  [/^\/app\/techpacks\/[^/]+\/print/, "pdf-exports"],
  [/^\/app\/techpacks/, "techpacks"],
  [/^\/app\/cad.*[?&]tab=illustrator/, "illustrator-panel"],
  [/^\/app\/cad(\/|$)/, "cad-library"],
  [/^\/app\/artwork/, "artwork-library"],
  [/^\/app\/rd/, "rd"],
  [/^\/app\/garments/, "garments"],
  [/^\/app\/items\/[^/]+.*[?&]tab=skus/, "garment-skus"],
  [/^\/app\/items\/[^/]+.*[?&]tab=packing/, "garment-packing"],
  [/^\/app\/items\/[^/]+.*[?&]tab=costing/, "garment-costing"],
  [/^\/app\/items\/[^/]+.*[?&]tab=compliance/, "garment-certificates"],
  [/^\/app\/items\/[^/]+\/datasheet/, "product-datasheets"],
  [/^\/app\/items\/new\/fabric/, "fabrics"],
  [/^\/app\/items\/new\/trim/, "trims"],
  [/^\/app\/items/, "garments"],
  [/^\/app\/fabrics/, "fabrics"],
  [/^\/app\/trims/, "trims"],
  [/^\/app\/tasks/, "my-tasks"],
  [/^\/app\/database\/suppliers/, "suppliers"],
  [/^\/app\/database\/agents/, "agents"],
  [/^\/app\/database\/logistics/, "logistics-providers"],
  [/^\/app\/finance\/po\//, "supplier-payments"],
  [/^\/app\/finance\/ledgers/, "ledgers"],
  [/^\/app\/finance\/lc/, "letters-of-credit"],
  [/^\/app\/finance\/shipments/, "freight-logistics"],
  [/^\/app\/finance\/legacy\/customs/, "customs-duty"],
  [/^\/app\/finance\/customs\//, "customs-duty"],
  [/^\/app\/finance\/landed/, "landed-cost-per-item"],
  [/^\/app\/finance\/reports\/more.*[?&]tab=accounting/, "accounting-export"],
  [/^\/app\/finance\/reports\/more.*[?&]tab=wht/, "withholding-tax"],
  [/^\/app\/finance\/reports\/more.*[?&]tab=lc/, "letters-of-credit"],
  [/^\/app\/finance\/export/, "export-to-accounting"],
  [/^\/app\/finance\/claims/, "claims"],
  [/^\/app\/finance\/reports/, "finance-reports"],
  [/^\/app\/settings\/finance.*[?&]tab=rates/, "exchange-rates"],
  [/^\/app\/settings\/finance.*[?&]tab=terms/, "payment-terms"],
  [/^\/app\/settings\/finance.*[?&]tab=nominals/, "nominal-codes"],
  [/^\/app\/settings\/finance.*[?&]tab=types/, "ledger-accounts"],
  [/^\/app\/settings\/finance.*[?&]tab=accexport/, "export-to-accounting"],
  [/^\/app\/settings\/finance.*[?&]tab=claims/, "claims"],
  [/^\/app\/settings\/finance.*[?&]tab=accounts/, "accounting-export"],
  [/^\/app\/settings\/finance/, "finance-setup"],
  [/^\/app\/users\/[^/]+\/access/, "which-orders"],
  [/^\/app\/users/, "users-permissions"],
  [/^\/app\/settings\/(database|custom-fields)/, "database-lists"],
  [/^\/app\/settings\/languages/, "languages"],
  [/^\/app\/settings\/codes/, "codes-numbering"],
  [/^\/app\/(settings\/)?(import|transfer)/, "import-export"],
  [/^\/app\/setup/, "setup-wizard"],
  [/^\/app\/settings\/(features|profile)/, "organisation-profile"],
  [/^\/app\/settings\/backup/, "backups"],
  [/^\/app\/settings\/email-log/, "email-settings"],
  [/^\/app\/settings\/digest/, "weekly-digest"],
  [/^\/app\/settings\/certificates/, "compliance"],
  [/^\/app\/settings\/qc/, "qc-settings"],
  [/^\/app\/settings\/seals/, "gold-seal"],
  [/^\/app\/settings\/timeline/, "order-timeline"],
  [/^\/app\/settings\/datasheets/, "product-datasheets"],
  [/^\/app\/settings\/logistics/, "po-container-planning"],
  [/^\/app\/settings\/inventory/, "inventory-settings"],
  [/^\/app\/settings\/exchange-rates/, "exchange-rates"],
  [/^\/app\/settings\/profile/, "organisation-profile"],
  [/^\/app\/settings\/api.*[?&]tab=guide/, "api-guide"],
  [/^\/app\/settings\/api.*[?&]tab=zapier/, "zapier"],
  [/^\/app\/settings\/api/, "api-connections"],
  [/^\/app\/settings/, "settings-overview"],
  [/^\/app\/account/, "account-security"],
  [/^\/app\/help\/support|^\/app\/help\/tickets/, "contact-support"],
  [/^\/app\/?$/, "dashboard"],
];
/** The manual page for a screen. `menu` is the sidebar item on show (a fabric and a garment share /app/items/:id). */
export function contextPage(pathWithQuery: string, menu = ""): string {
  for (const [re, id] of CONTEXT_HELP) {
    if (!re.test(pathWithQuery)) continue;
    if (id === "garments" && menu === "fabric") return "fabrics";
    if (id === "garments" && menu === "trims") return "trims";
    return id;
  }
  return "welcome";
}

/** Support ticket choices. */
export const TICKET_CATEGORIES: Array<[string, string]> = [["question", "Question"], ["problem", "Problem or error"], ["feature", "Feature request"], ["billing", "Billing & licences"], ["access", "Account & access"]];
export const TICKET_PRIORITIES: Array<[string, string]> = [["low", "Low"], ["normal", "Normal"], ["high", "High"], ["urgent", "Urgent – Falcon is down or I can't work at all"]];
export const TICKET_STATUSES: Array<[string, string]> = [["new", "New"], ["open", "Open"], ["waiting", "Waiting for you"], ["resolved", "Resolved"], ["closed", "Closed"]];
export const TICKET_STATUS_LABEL = Object.fromEntries(TICKET_STATUSES) as Record<string, string>;
/** Default response targets: hours to the first reply. Urgent counts every hour; the others count weekdays only
 *  (High 1 business day, Normal 2, Low 5). The Owner can change them in Console → Support → Settings. */
export const DEFAULT_TARGETS: Record<string, number> = { urgent: 4, high: 24, normal: 48, low: 120 };
/** When the first reply is due: `hours` after `from`, skipping Saturdays and Sundays unless the ticket is Urgent. */
export function replyDue(from: Date, hours: number, priority: string): Date {
  if (priority === "urgent") return new Date(from.getTime() + hours * 3600_000);
  let t = from.getTime(), left = Math.max(0, Math.round(hours));
  while (left > 0) {
    t += 3600_000;
    const d = new Date(t).getUTCDay();
    if (d !== 0 && d !== 6) left--;   // weekend hours don't count
  }
  return new Date(t);
}
export const REOPEN_DAYS = 14;
export const MAX_ATTACHMENT_MB = 10;
